import { render, staticRenderFns } from "./lang-switch.vue?vue&type=template&id=5db0fca2&scoped=true&"
import script from "./lang-switch.vue?vue&type=script&lang=ts&"
export * from "./lang-switch.vue?vue&type=script&lang=ts&"
import style0 from "./lang-switch.vue?vue&type=style&index=0&id=5db0fca2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0fca2",
  null
  
)

export default component.exports